<script>
    // This component takes a string and key, where the key lets us slot
    // a component into the string
    // e.g. str = "Preview: {balance}", key = "balance"
    // becomes Preview: <slot></slot>
    export let str;
    export let key;

    let idxToSubComp;

    $: splitStrByKey = str.split(/\{(.+?)\}/g);
    $: {
        // using for loop instead of .findIndex bc babel is not seeing .findIndex to transpile
        for (let i = 0; i < splitStrByKey.length; i++) {
            if (splitStrByKey[i] === key) {
                idxToSubComp = i;
            }
        }
    }
</script>

{#each splitStrByKey as string, idx}
    {#if idx === idxToSubComp}
        <slot></slot>
    {:else}
        {string}
    {/if}
{/each}


